import React, { useState } from "react";
import { Button, Col, Container, Image, Row, Card } from "react-bootstrap";
import { IMAGES } from "constants/images";
import ArrowIcon from "components/ArrowIcon";
import TestimonialSlider from "components/TestimonialSlider";
import { useUserRole } from "services/provider";
import Modals from "inc/Modals";
import { useAuth } from "context/UserContext";
import { useLocation, useNavigate } from "react-router-dom";

const highlights = [
  {
    icon: IMAGES.Vendor_Icon1_IMG,
    title: "Amplify Customer Feedback",
    description:
      "We simplify the process of gathering customer feedback, ensuring their voices are heard and helping you build trust.",
  },
  {
    icon: IMAGES.Vendor_Icon2_IMG,
    title: "One Easy Platform",
    description:
      "Access all the tools you need to capture customer feedback and leverage intent data to drive informed business decisions.",
  },
  {
    icon: IMAGES.Vendor_Icon3_IMG,
    title: "Win More Deals",
    description:
      "Track in-market buyers, boost win rates, and reduce churn with actionable intent signals for better outcomes.",
  },
];

const ForVendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, user } = useAuth();
  const [modalType, setModalType] = useState("");
  const { role, setRole } = useUserRole();

  return (
    <React.Fragment>
      {/* Banner Section */}
      <section
        className="banner_section banner_section1"
        style={{ backgroundImage: `url(${IMAGES.Banner_Img})` }}
      >
        <Container>
          <Row>
            <Col md={12}>
              <h1>Trusted Reviews to Grow Your Business.</h1>
              <p className="mb-5">
                Harness the power of genuine customer reviews to establish
                trust, enhance your reputation, and drive business growth. By
                showcasing real user experiences, you can attract more clients
                and make data-driven decisions that lead to long-term success.
              </p>
              <Image
                src={IMAGES.Vendor_Home_IMG}
                className="img-fluid"
                alt=""
              />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Categories Section */}
      <section
        className="py80 categories_section"
        style={{ backgroundImage: `url(${IMAGES.Gradient1_Img})` }}
      >
        <Container>
          <h2 className="text-center mb-5">
            Empowering Tech Vendors to Sell with Trust!
          </h2>
          <Row>
            <Col >
              <Row className="mb-3">
                {highlights.map((item, index) => (
                  <Col key={index} lg={4} md={4} sm={4} className="mb-4">
                    <Card className="text-center valueCard valueCard1">
                      <Image src={item.icon} alt="" />
                      <Card.Title className="fw-bold">{item.title}</Card.Title>
                      <Card.Text>{item.description}</Card.Text>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
            <div className="centerBtn text-center">
              <Button
                onClick={() => {
                  setModalType("login");
                  setRole("vendor");
                  if (isLoggedIn && user.role === "vendor") {
                    setModalType("login");
                  }
                }}
                className="border-radius-100 px-5"
                variant="info"
              >
                Join Us <ArrowIcon color="#ffffff" />
              </Button>
            </div>
          </Row>
        </Container>
      </section>
      {/* Review Section */}
      <section className="py80 review_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} md={6} className="mb-4 mb-lg-0 d-flex justify-content-center">
              <Image
                src={IMAGES.Vendor_Icon4_IMG}
                alt="Review"
                className="img-fluid"
              />
            </Col>
            <Col lg={6} md={6}>
              <h2>
                Reach More Potential
                <br />
                Buyers for Your Software.
              </h2>
              <p>
                Experience seamless coordination and personalized attention with
                our Dedicated Project Manager. From inception to execution, your
                project will be in expert hands, ensuring efficient
                communication, timely deliverables, and a tailored approach that
                meets your unique objectives.
              </p>
              <Button
               onClick={() => {
                setModalType("login");
                setRole("vendor");
                if (isLoggedIn && user.role === "vendor") {
                  setModalType("login");
                }
              }}
                className="border-radius-100"
                variant="info"
              >
                Claim Your Profile <ArrowIcon color="#ffffff" />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Client Section */}
      <section className="py80 client_section position-relative">
        <Container className="position-relative z-1">
          <h2 className="text-center mb-5">What they Say About Us!</h2>
          <Row className="align-items-center">
            <Col lg={12} className="position-relative">
              <Image
                src={IMAGES.Clientsvg1_Img}
                alt="Review"
                className="img-fluid shapeImg1 z-0"
              />
              <TestimonialSlider />
            </Col>
          </Row>
        </Container>
        <Image
          src={IMAGES.Clientsvg2_Img}
          alt="Review"
          className="img-fluid shapeImg2 z-0"
        />
      </section>
      <Modals
        modalType={modalType}
        navigateTo={location.pathname || "/"}
        setModalType={setModalType}
        handleCloseModal={() => {
          setModalType("");
        }}
        {...{
          role: "vendor",
          navigate,
        }}
      />
    </React.Fragment>
  );
};
export default ForVendor;
